import React, { useEffect, useState } from "react";
import Repo from "../../Repository/Repo";

function useGetBanks() {
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    getBanks();
  }, []);

  const getBanks = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setBanks(data.response.data.banks);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  return { loading: loading, banks: banks };
}

export default useGetBanks;
